import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { INameLookupProps } from "./INameLookupProps";
import { ITableLookup } from "../../../../base/models";
import { useGetLookupLabel } from "./useGetLookupLabel";

export const NameLookupProperties = [
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
]

export const useNameLookupProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<INameLookupProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.InitValue })
    const { getLookupLabel, isLoading } = useGetLookupLabel()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const tableLookup = bindings.getValue<ITableLookup>(Property.TableLookup);
        const value = bindings.getValue<string>(Property.InitValue);
        getLookupLabel({ tableLookup, value })
            .then(label => {
                setProperties({ label })
            })
            
        // eslint-disable-next-line
    }, [bindings, status]);

    return {
        status: isLoading ? FetchStatus.Loading : status,
        error,
        bindings,
        properties,
        draftText
    }
}
